import React from "react";
import AdminLogin from "../components/auth/login/AdminLogin";

const Office = () => {
  return <AdminLogin />;
};

export default Office;
